import { render } from "./GameSpeed.vue?vue&type=template&id=b9fa5bb2&scoped=true"
import script from "./GameSpeed.vue?vue&type=script&lang=js"
export * from "./GameSpeed.vue?vue&type=script&lang=js"

import "./GameSpeed.vue?vue&type=style&index=0&id=b9fa5bb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9fa5bb2"]])

export default __exports__